import axios from "axios";
import { baseUrl } from "../config/api-config";

export const assignEmployeeToProject = (data, token) =>
  axios.post(`${baseUrl}/employee-project`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteEmployeeProject = (id, token) =>
  axios.delete(`${baseUrl}/employee-project/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const updateEmployeeProject = (data, token) =>
  axios.post(`${baseUrl}/employee-task-update`, data, {
    headers: {
      authorization: token,
    },
  });
